import React from 'react';

export interface CardProps {
  children: React.ReactNode;
  variant?: 'default' | 'stats' | 'content' | 'plot' | 'table' | 'action-bar' | 'config';
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  hover?: boolean;
  clickable?: boolean;
  loading?: boolean;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  overflow?: 'hidden' | 'visible' | 'auto';
}

const Card: React.FC<CardProps> = ({
  children,
  variant = 'default',
  size = 'md',
  hover = true,
  clickable = false,
  loading = false,
  className = '',
  style,
  onClick,
  overflow = 'hidden',
}) => {
  const getVariantClasses = () => {
    const overflowClass =
      overflow === 'hidden'
        ? 'overflow-hidden'
        : overflow === 'auto'
          ? 'overflow-auto'
          : 'overflow-visible';
    const baseClasses = `bg-white rounded-xl shadow-sm ${overflowClass} transition-shadow`;

    const variantClasses = {
      default: '',
      stats: '',
      content: '',
      plot: 'bg-white',
      table: '',
      'action-bar': '',
      config: '',
    };

    const sizeClasses = {
      sm: 'p-4',
      md: 'p-6',
      lg: 'p-8',
      xl: 'p-10',
      full: 'p-6',
    };

    const interactionClasses = [
      hover && 'hover:shadow-md',
      clickable && 'cursor-pointer hover:shadow-lg',
      loading && 'opacity-60 pointer-events-none',
    ]
      .filter(Boolean)
      .join(' ');

    return [baseClasses, variantClasses[variant], sizeClasses[size], interactionClasses, className]
      .filter(Boolean)
      .join(' ');
  };

  return (
    <div className={getVariantClasses()} style={style} onClick={onClick}>
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-10">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-onyx-bright-blue"></div>
        </div>
      )}
      {children}
    </div>
  );
};

export default Card;
